import request from '../index.js'

// 合同模板管理API
export const contractApi = {
  // 获取模板列表
  getTemplateList(params) {
    return request.get('/admin/contract-templates', { params })
  },

  // 获取模板详情
  getTemplate(id) {
    return request.get(`/admin/contract-templates/${id}`)
  },

  // 创建模板
  createTemplate(data) {
    return request.post('/admin/contract-templates', data)
  },

  // 更新模板
  updateTemplate(id, data) {
    return request.put(`/admin/contract-templates/${id}`, data)
  },

  // 删除模板
  deleteTemplate(id) {
    return request.delete(`/admin/contract-templates/${id}`)
  },

  // 获取合同列表
  getContractList(params) {
    return request.get('/admin/contracts', { params })
  },

  // 获取合同详情
  getContract(id) {
    return request.get(`/admin/contracts/${id}`)
  },

  // 更新合同状态
  updateContractStatus(id, data) {
    return request.put(`/admin/contracts/${id}/status`, data)
  },

  // 获取合同统计
  getContractStats() {
    return request.get('/admin/contracts/stats')
  }
}

export default contractApi
